export default {"src":"/_next/static/media/python.4ef95129.svg","height":255,"width":256,"blurWidth":0,"blurHeight":0};